import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import Seo from "@/components/Seo";
import { Container, SectionLabel, Reveal } from "@/components/primitives";
import { api, mediaSrc } from "@/lib/api";

export default function Journal() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.listJournal().then(setItems).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-lux-bg">
      <Seo title="Journal · Onedot6" description="Reflections on final styling, the bespoke process, lighting and the long arc of designer collaborations." path="/journal" />
      <TopBar />
      <Container className="pt-32 md:pt-40 pb-24">
        <SectionLabel>Notes on Designing Around YÜ</SectionLabel>
        <h1 className="font-serif text-lux-ink font-light tracking-tight leading-none mt-2 text-5xl md:text-7xl lg:text-8xl">Journal.</h1>
        <p className="text-base md:text-lg text-lux-sec font-light leading-relaxed mt-5 max-w-[720px]">
          Reflections on final styling, the bespoke process, lighting and the long arc of designer collaborations.
        </p>
        <div className="mt-12 md:mt-20 grid md:grid-cols-3 gap-x-8 gap-y-12">
          {loading
            ? Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-[360px] bg-lux-line animate-pulse" />)
            : items.map((j) => (
                <Reveal key={j.id}>
                  <Link to={`/journal/${j.id}`} data-testid={`journal-item-${j.id}`} className="group block">
                    <div className="overflow-hidden bg-lux-line h-[340px] md:h-[360px] mb-4">
                      <img src={mediaSrc(j.image_url)} alt={j.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    </div>
                    <p className="text-[11px] tracking-[0.25em] text-lux-accent mb-2.5">{(j.category || "").toUpperCase()}</p>
                    <h2 className="font-serif text-2xl text-lux-ink font-light leading-snug mb-2.5">{j.title}</h2>
                    <p className="text-[15px] text-lux-sec leading-relaxed font-light">{j.excerpt}</p>
                  </Link>
                </Reveal>
              ))}
        </div>
      </Container>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
